
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shields",
      function () {
        return require("private-next-pages/shields/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shields"])
      });
    }
  